import { callStoreState} from '../models/meetModal';
import {actionTypes} from '../action/action';

const initialState = {
  participantList: [],
  midValue: 2,
  callStatus: "Waiting",
  socketData: [],
  iswaiting: false,
  activeSpeaker: [],
  videoResolution: 640,
  currentBandwidth: 1000
};

export const storeVideo = (state:callStoreState  = initialState, action: any) => {
  const {
    type,
    payload
  } = action;
  switch (type) {
  case actionTypes.PARTICIPANT_VIDEO_INFO:
    return {
      ...state, participantList: payload.participant, midValue:payload.midValue,callStatus:payload.callStatus
    };
  case actionTypes.CALL_STATUS:
    return {
      ...state, callStatus: payload
    };
  case actionTypes.CALL_WAITING_STATUS:
    return {
      ...state, iswaiting: payload
    };
  case actionTypes.CALL_SYNC_STORE:
    return {
      ...state, socketData: payload
    };
  case actionTypes.ACTIVE_SPEAKER:
    return {
      ...state, activeSpeaker: payload
    };
  case actionTypes.VIDEO_RESOLUTION:
    return {
      ...state, videoResolution: payload
    };
  case actionTypes.VIDEO_BANDWIDTH:
    return {
      ...state, currentBandwidth:payload
    };
  default:
    return state;
  };
};

